<template>
  <div>
    <header-bar>マイアーティスト</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">マイアーティスト一覧</h3>
      </div>
      <div class="page-block__inner">
        <div class="my-arthist-btn-wrap">
          <div class="my-artist-search-wrap">
            <div class="my-artist-search-text">アーティスト検索</div>
            <input
              v-model="keyword"
              class="my-artist-search"
              type="search">
          </div>
          <router-link
            :to="{ name : 'artist-create' }"
            class="c-btn c-btn--artist">
            <svg
              class="icon-add_artist_white svg-icon"
              viewBox="0 0 47.105 50.01">
              <path
                class="color-wh"
                d="M17.4,21c-5.2,0-9.5-5.1-9.5-11.4c0-5.8,3.7-9.6,9.5-9.6s9.5,3.8,9.5,
                9.6C26.9,15.9,22.6,21,17.4,21z M17.4,2c-4.7,0-7.6,2.8-7.6,7.6c0,5.2,
                3.4,9.5,7.6,9.5s7.6-4.2,7.6-9.5C24.9,4.8,22.1,2,17.4,2L17.4,2z" />
              <path
                class="color-wh"
                d="M30.7,24.2c-0.8,0.2-1.5,0.5-2.2,0.8c-1.2-0.8-2.7-1.2-4.2-1.1h-0.4l-5.7,
                5.4c-0.4,0.4-1,0.4-1.4,0l-5.7-5.4h-0.4C6,23.9,2.1,27.6,2,32.4v10.9c0.1,2.5,
                2,4.6,4.5,4.7V36.7c0-0.6,0.5-1,1-1c0.5,0,1,0.4,1,1V49c0,0.6-0.5,1-1,1H7C3.2,
                50,0.1,47,0,43.2V32.4c0.1-5.8,4.9-10.5,10.7-10.4h0.8c0.3,0,0.5,0.1,0.7,
                0.3l5.3,5l5.3-5c0.2-0.2,0.4-0.3,0.7-0.3h0.8C26.6,21.8,29,22.6,30.7,24.2z" />
              <path
                class="color-wh"
                d="M35.1,26c-0.4,0-0.8,0-1.1,0.1c-0.4,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.7,0.1-1,
                0.2l0,0c-0.3,0.1-0.7,0.2-1,0.3c-0.3,0.1-0.5,0.2-0.8,0.3l0,0c-1,0.5-2,1.1-2.8,
                1.9L27,29.2c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.6,
                0.6-0.8,1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.5s-0.2,0.3-0.3,
                0.4c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.5c-0.1,0.1-0.1,0.3-0.2,
                0.4c-0.1,0.3-0.2,0.6-0.3,0.9c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.1,0.5-0.2,0.8c0,
                0.1,0,0.2-0.1,0.4c0,0.2-0.1,0.5-0.1,0.8c0,0.1,0,0.2,0,0.3c0,0.4-0.1,0.7-0.1,
                1.1c0,0.4,0,0.8,0.1,1.2c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0.1,0.3,
                0.1,0.5,0.2,0.8c0,0.1,0.1,0.2,0.1,0.4c0.1,0.3,0.2,0.6,0.3,0.9c0,0.1,0,0.1,0.1,
                0.2c0.1,0.3,0.3,0.6,0.4,0.9c0,0,0,0.1,0,0.1c0.2,0.3,0.4,0.6,0.6,0.9v0c0.3,0.4,
                0.6,0.8,0.9,1.2c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.6,
                0.6,1,0.9c0.3,0.3,0.7,0.6,1.1,0.8h0c0.4,0.3,0.8,0.5,1.2,0.7c0,0,0.1,0,0.1,
                0.1c0.4,0.2,0.8,0.4,1.3,0.5c0.3,0.1,0.6,0.2,0.9,0.3l0.1,0c0.3,0.1,0.5,0.1,0.8,
                0.2c0.1,0,0.3,0,0.4,0.1c0.2,0,0.4,0.1,0.6,0.1c0.4,0,0.7,0.1,1.1,0.1c6.6,0,
                12-5.4,12-12C47.1,31.4,41.7,26,35.1,26z M35.1,48c-5.5,0-10-4.5-10-10s4.5-10,
                10-10c5.5,0,10,4.5,10,10C45.1,43.5,40.6,48,35.1,48z" />
              <path
                class="color-wh"
                d="M40.1,37h-4v-4c0-0.6-0.4-1-1-1s-1,0.4-1,1v4h-4c-0.6,0-1,0.4-1,1s0.4,1,1,
                1h4v4c0,0.6,0.4,1,1,1s1-0.4,1-1v-4h4c0.6,0,1-0.4,1-1S40.7,37,40.1,37z" />
            </svg>新規アーティスト登録
            <span class="c-btn__icon-arrow"></span>
          </router-link>
        </div>
        <div
          v-if="serachStatus === 0"
          class="artist-list">
          <a
            v-for="item in pagination.data"
            :key="item.id"
            class="artist-list__item"
            href="">
            <router-link :to="{ name : 'artist-detail', params : { id: item.id } }">
              <div
                class="artist-list__pic"
                :style="`background-image: url(/images/${item.image_path})`">
              </div>
              <div class="artist-list__name">
                <span class="artist-list__name_text">
                  {{ item.name }}
                </span>
                <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
              </div>
            </router-link>
          </a>
        </div>
        <div
          v-else-if="serachStatus === 1"
          class="artist-list">
          <p class="artist-not-exist">
            このキーワードのアーティストは登録されていません。
          </p>
        </div>
        <div
          v-else
          class="artist-list">
          <p class="artist-not-exist">
            アーティストが登録されていません。
          </p>
        </div>
        <div class="pager">
          <div
            v-if="pagination.data"
            class="pager">
            <pagination
              :pagination="pagination"
              @on-pagination-clicked="onPaginationClicked">
            </pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Pagination from '../../../components/Pagination'
import HeaderBar from '../HeaderBar'

let timer = null
export default {
  name: 'ArtistIndex',
  components: {
    HeaderBar,
    Pagination,
  },
  data() {
    return {
      pagination: [],
      keyword: '',
      serachStatus: 0,
    }
  },
  watch: {
    keyword() {
      this.onSearchKeywordChanged()
    },
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    onSearchKeywordChanged() {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => { this.fetchItems(0) }, 800)
    },
    async fetchItems(page) {
      const { data } = await window.axios.get('/api/client/artists', {
        params: {
          count: this.pagination.per_page,
          type: 1,
          keyword: this.keyword,
          optional_kana: 1,
          page,
        },
      })
      this.pagination = data
      if (Object.keys(this.pagination.data).length > 0) {
        this.serachStatus = 0
      } else if (Object.keys(this.pagination.data).length <= 1 && this.keyword) {
        this.serachStatus = 1
      } else {
        this.serachStatus = 2
      }
    },
    onPaginationClicked(page) {
      this.fetchItems(page)
      window.scrollTo(0, 0)
    },
  },
}
</script>
